import { Typography } from '@material-ui/core';
import { Cards, CustomIcon, Button } from 'ams-ui-reactkit';
import { AmsFamily } from '../../../assets/images';
import { TemplateProps } from '../../../journeys/journey/Interfaces'
import './CustAckThankyou.scss'
import DynamicHtml from "../../../molecules/DynamicHtml"

const CustAckThankyou: React.FC<TemplateProps> = (props: any) => {
    const { templateProps } = props;

    const { script, content } = templateProps
    const showCloseBtnFlag = process.env.REACT_APP_SHOW_CLOSE_ON_LAST_PAGE ? process.env.REACT_APP_SHOW_CLOSE_ON_LAST_PAGE === "true" : false

    const showCloseButton = () => {

        if (showCloseBtnFlag) {

            return <div className={`staticFixedButton mt-8 in-active-btn-thank`}>
                <Button
                    text="Close"
                    onClick={() => {
                        window.location.href = "/close";
                    }}
                    color="primary"
                    variant="contained"
                    size="large"
                />
            </div>
        }

        return null;

    }

    return (
        <div className="baseContainerBlock mb-0">
            <div className={`thanksScreen ${showCloseBtnFlag ? 'mb-40' : ''}`}>
                {script && <Cards variant="primary">
                    <div className="thankyoumain">
                        <div className="thankyouimg">
                            <CustomIcon iconName="thankyou" />
                        </div>
                        <Typography variant="body1" component="span" className="thankyoudesc">
                            <DynamicHtml content={script} />
                        </Typography>
                    </div>

                </Cards>}

                {content && <div className={"custAckMainBlk"}><Cards variant="default">
                    <div className="custAckMain">
                        <div className="custAckMainimg">
                            <img src={AmsFamily} alt="" />
                        </div>
                        <Typography variant="subtitle2" component="div" className="custAckMaindesc">
                            <DynamicHtml content={content} />
                        </Typography>
                    </div>
                </Cards>
                </div>}

                {showCloseButton()}
            </div>

        </div>
    )
}

export default CustAckThankyou